import axios from 'axios'
import cookie from '~/utils/cookie'
import { aseDecrypt } from '../utils/crypto'
import { baseURL, baseURL2, baseURL3 } from '../config/index'

// 30秒中断请求
axios.defaults.timeout = 30000

// 拦截发送请求
axios.interceptors.request.use(
  config => {
    let token = location.pathname.indexOf('/xueshi-iJournal') === 0 ? cookie.get('xueshi-token') : cookie.get('T_j_web_token')
    token && (config.headers.Authorization = 'Bearer ' + token)
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 拦截返回结果
axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      let token
      if (res.headers && res.headers.authorization) {
        token = res.headers.authorization.substr(7)
        location.pathname.indexOf('/xueshi-iJournal') === 0 ? cookie.set('xueshi-token', token) : cookie.set('T_j_web_token', token)
      }
      if (res.data.code === 0) {
        if (res.config.url.indexOf(baseURL) > -1) {
          // 解密
          res.data.data = aseDecrypt(res.data.data)
        }
      }
      // 如果token过期 跳转到首页 打开登录弹窗 让用户登录
      if (res.data.code === 10127 || res.data.code === 10126 || res.data.code === 10117) {
        localStorage.setItem('userInfo', JSON.stringify({
          id: '',
          userPhone: '',
          userName: '',
          nickName: '',
          avatarUrl: '',
          userEmail: '',
          // 学校
          university: '',
          // 专业
          userMajor: ''
        }))
        if (location.pathname.indexOf('/xueshi-iJournal') === 0) {
          location.href = '/xueshi-iJournal/home?login=xueshi'
        } else {
          // 跳转到首页并打开弹窗
          location.href = '/home?login=1'
        }
        // token失效
        cookie.remove('T_j_web_token')
      }
    }
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * request封装
 */
function fetchData (method, url, data = {}, source = '') {
  let base = ''
  switch (source) {
    case 'java':
      base = baseURL2
      break
    case 'java2':
      base = baseURL3
      break
    default:
      base = baseURL
      break
  }

  return new Promise((resolve, reject) => {
    let request
    if (method === 'get' || method === 'delete') {
      request = axios[method](base + url, { params: data })
    } else {
      request = axios[method](base + url, data)
    }
    request
      .then(res => {
        console.log('7878', res)
        resolve(res)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export function get (url, params, source) {
  return fetchData('get', url, params, source)
}

export function post (url, data, source) {
  return fetchData('post', url, data, source)
}

export function put (url, data, source) {
  return fetchData('put', url, data, source)
}

export function remove (url, params, source) {
  return fetchData('delete', url, params, source)
}

export function upload (url, data, source) {
  const formData = new FormData()
  Object.keys(data).forEach((child) => {
    formData.append(child, data[child])
  })
  return post(url, formData, source)
}



// WEBPACK FOOTER //
// ./src/api/config.js